import * as React from 'react';
import {
  ActionButton,
  addRowToPayload,
  fetchApi,
  getInitialValuesExistingRow,
  makeCompoundPayload,
  notifyError,
  notifyResponse,
  useCacheRecord,
} from 'gossamer-front-end';
import { Attendance, AttendanceRow } from 'cb-model';
import { useNavigate } from 'react-router-dom';

export interface AttendanceDeleteButtonProps {
  attendance_id: string;
}

export const AttendanceDeleteButton: React.FC<AttendanceDeleteButtonProps> = (props) => {
  const navigate = useNavigate();
  const { data, error } = useCacheRecord<AttendanceRow>(Attendance, props.attendance_id);
  if (!!error) {
    console.error(error);
  }
  return (
    <ActionButton
      label="Delete Attendance Record"
      size="sm"
      variant="danger"
      waiting={!data}
      execute={async (resetCache) => {
        try {
          const payload = makeCompoundPayload('save');
          const row = getInitialValuesExistingRow(Attendance, data);
          row._deleting = true;
          addRowToPayload(payload, Attendance, row);
          const response = await fetchApi('POST', `/main/~/attendance-delete`, payload);
          resetCache(Attendance.id, props.attendance_id);
          notifyResponse(response);
          navigate('/admin/');
        } catch (e) {
          notifyError(e, 'An error occurred while deleting the attendance record');
        }
      }}
    />
  );
};
